var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Circle, Defs, ClipPath } from "react-native-svg";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_3030_10297)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5C0 4.977 4.477.5 10 .5s10 4.477 10 10c0 2.198-.71 4.232-1.912 5.882-.325.447-.962.48-1.374.112-.412-.368-.441-.997-.127-1.452a8 8 0 1 0-13.144.042c.317.453.291 1.082-.119 1.452-.41.371-1.046.342-1.374-.102A9.96 9.96 0 0 1 0 10.5Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 7.5,
    cy: 18.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 12.5,
    cy: 18.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.207 5.207-4.5 4.5-1.414-1.414 4.5-4.5 1.414 1.414Z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_3030_10297"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(0 .5)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSpeed;